/**
 * RoleGate: shows its children only when the user's organisation role allows `cap` (backend
 * services/role_policy.py); otherwise a short note, or nothing with `quiet`. Used for whole pages
 * (campaign wizard, branding) and for blocks of actions.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';
import { useCan, useFeature } from '../contexts/AuthContext';

export function RoleNote({ cap, className = '' }) {
  const { t } = useTranslation('common');
  return (
    <div className={`panel role-note ${className}`} role="note" data-testid={`role-note-${cap}`}>
      <Lock size={16} aria-hidden="true" />
      <span>{t(`role_note_${cap}`, { defaultValue: t(`role_denied_${cap}`) })}</span>
    </div>
  );
}

export default function RoleGate({ cap, quiet = false, children }) {
  return useCan(cap) ? children : quiet ? null : <RoleNote cap={cap} />;
}

/** A page of a licence package feature (PRD §4): without any of `codes` in the organisation's package, its
 * address opens the portal home instead (QA AD-01). */
export function FeatureRoute({ codes, home, children }) {
  const list = Array.isArray(codes) ? codes : [codes];
  return useFeature(...list) ? children : <Navigate to={home} replace />;
}
